import React from 'react'
import { FormattedRelativeTime, FormattedTime, FormattedDate } from 'react-intl'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { selectRelativeUnits } from '../../../../components/react-intl-helpers'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'

export function getFirstSeenCellRenderer({
  firstObservedTime
}: {
  firstObservedTime: string
}) {
  const { value, unit } = selectRelativeUnits(new Date(firstObservedTime))

  return (
    <FormattedRelativeTime
      value={value}
      unit={unit}
      numeric="auto"
      children={(dateString) => (
        <Tooltip
          body={
            <FormattedDate value={firstObservedTime}>
              {(dateText) => (
                <FormattedTime value={firstObservedTime}>
                  {(timeText) => <span children={`${dateText} ${timeText}`} />}
                </FormattedTime>
              )}
            </FormattedDate>
          }
        >
          <span
            className={css`
              color: ${theme.color.neutral60};
              line-height: normal;
            `}
          >
            {dateString}
          </span>
        </Tooltip>
      )}
    />
  )
}
